import useId from '../utils/useId';
import * as React from 'react';
export const MKSvg = React.forwardRef(function MKSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement('path', {
        id: `fi_FlagIcon-MK__a_${id_0}`,
        d: 'M1.24.15A1.95 1.95 0 0 1 1.994 0H6.75l.75 3h1l.75-3h4.756c.267 0 .523.053.756.15L10 3.139l.47.883L16 2v2.5l-5 1v1l5 1v2.49l-5.53-1.873L10 9l4.755 2.853a1.972 1.972 0 0 1-.75.147H9.5l-1-3h-1l-1 3H1.994a1.96 1.96 0 0 1-.755-.15l4.797-2.986-.47-.883L0 9.99V7.5l5-1v-1l-5-1V2l5.567 2.022.469-.883L1.239.149ZM8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#FCD669',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        d: 'M1.994 0h12.012C15.106 0 16 .9 16 2.009V9.99A2.003 2.003 0 0 1 14.006 12H1.994C.894 12 0 11.1 0 9.991V2.01C0 .902.893 0 1.994 0Zm.013 1C1.45 1 1 1.456 1 1.995v8.01A1 1 0 0 0 2.007 11h11.986c.556 0 1.007-.456 1.007-.995v-8.01A1 1 0 0 0 13.993 1H2.007Z',
      }),
      /*#__PURE__*/ React.createElement('use', {
        fill: '#E25950',
        xlinkHref: `#fi_FlagIcon-MK__a_${id_0}`,
      }),
    ),
  );
});
MKSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MK = {
  category: 'flag',
  colorable: false,
  name: 'MK',
  svg: MKSvg,
};
